export const getDateFromString = (dateString?: string) => {
	if (dateString) {
		const offset = new Date().getTimezoneOffset() / 60
		const returnDate = new Date(dateString)
		returnDate.setHours(returnDate.getHours() + offset)
		return returnDate
	}
	return new Date()
}
